import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "./baseQuery";

export const userManagementAPI = createApi({
  reducerPath: "userManagementAPI",
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    changePassword: builder.mutation({
      query: (params) => ({
        url: "/api/accounts/dashboard/change_password/",
        method: "POST",
        body: params,
      }),
    }),
    getAdminUsers: builder.query({
      query: (params) => {
        return {
          url: "/api/accounts/admin-users/",
          params,
        };
      },
    }),
    createAdminUser: builder.mutation({
      query: (params) => ({
        url: "/api/accounts/admin-users/",
        method: "POST",
        body: params,
      }),
    }),
    updateAdminUser: builder.mutation({
      query: ({ id, ...params }) => ({
        url: `/api/accounts/admin-users/${id}/`,
        method: "PATCH",
        body: params,
      }),
    }),
    deleteAdminUser: builder.mutation({
      query: (id) => ({
        url: `/api/accounts/admin-users/${id}/`,
        method: "DELETE",
      }),
    }),
    updateAdminUserStatus: builder.mutation({
      query: ({ id, ...params }) => ({
        url: `/api/accounts/admin-users/${id}/status/`,
        method: "PATCH",
        body: params,
      }),
    }),
  }),
});

export const {
  useChangePasswordMutation,
  useLazyGetAdminUsersQuery,
  useCreateAdminUserMutation,
  useUpdateAdminUserMutation,
  useDeleteAdminUserMutation,
  useUpdateAdminUserStatusMutation,
} = userManagementAPI;

export default userManagementAPI;
